
// import assert from 'assert';

const FrameMaskClassName = 'frame-mask';

export function clearDragMask() {
    const maskList = window.document.querySelectorAll(`.${FrameMaskClassName}`);
    Array.from(maskList).forEach(mask => {
        mask.remove();
    });
}

export function createDragMask() {
    clearDragMask();
    const frameList = document.querySelectorAll('iframe');
    frameList.forEach(frame => {
        const rect = frame.getBoundingClientRect();
        const mask = window.document.createElement('div');
        mask.className = FrameMaskClassName;
        const style = [`left:${rect.left}px`, `top:${rect.top}px`, `width:${rect.width}px`, `height:${rect.height}px`];
        mask.setAttribute('style', style.join(';'));
        window.document.body.appendChild(mask);
    });
}
